import { SvgIcon, SvgIconProps } from '@mui/material';

const MeasureModelIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '1em'}
    height={props.height || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_4126_20606"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_4126_20606)">
      <path
        d="M4.30775 21.0021C3.80908 21.0021 3.38308 20.8255 3.02975 20.4723C2.67658 20.119 2.5 19.693 2.5 19.1943V5.80981C2.5 5.31115 2.67658 4.88515 3.02975 4.53181C3.38308 4.17865 3.80908 4.00206 4.30775 4.00206H9.7135C9.852 3.5149 10.135 3.11106 10.5625 2.79056C10.99 2.47006 11.4692 2.30981 12 2.30981C12.5513 2.30981 13.0382 2.47006 13.4605 2.79056C13.883 3.11106 14.1635 3.5149 14.302 4.00206H19.6922C20.1909 4.00206 20.6169 4.17865 20.9703 4.53181C21.3234 4.88515 21.5 5.31115 21.5 5.80981V19.1943C21.5 19.693 21.3234 20.119 20.9703 20.4723C20.6169 20.8255 20.1909 21.0021 19.6922 21.0021H4.30775ZM4.30775 19.5021H19.6922C19.7692 19.5021 19.8398 19.47 19.9038 19.4058C19.9679 19.3418 20 19.2713 20 19.1943V5.80981C20 5.73281 19.9679 5.66231 19.9038 5.59831C19.8398 5.53415 19.7692 5.50206 19.6922 5.50206H16.5V8.11731H7.5V5.50206H4.30775C4.23075 5.50206 4.16025 5.53415 4.09625 5.59831C4.03208 5.66231 4 5.73281 4 5.80981V19.1943C4 19.2713 4.03208 19.3418 4.09625 19.4058C4.16025 19.47 4.23075 19.5021 4.30775 19.5021ZM12 5.61756C12.2577 5.61756 12.4728 5.53132 12.6453 5.35882C12.8176 5.18632 12.9038 4.97123 12.9038 4.71357C12.9038 4.4559 12.8176 4.24082 12.6453 4.06832C12.4728 3.89598 12.2577 3.80981 12 3.80981C11.7423 3.80981 11.5272 3.89598 11.3547 4.06832C11.1824 4.24082 11.0963 4.4559 11.0963 4.71357C11.0963 4.97123 11.1824 5.18632 11.3547 5.35882C11.5272 5.53132 11.7423 5.61756 12 5.61756Z"
        fill="currentColor"
      />
      <mask
        id="mask1_4126_20606"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="7"
        width="14"
        height="14"
      >
        <rect x="5.28613" y="7.09644" width="13.4281" height="13.4281" fill="currentColor" />
      </mask>
      <g mask="url(#mask1_4126_20606)">
        <path
          d="M14.2374 18.0067V14.7035H16.1956V18.0067H14.2374ZM11.0202 18.0067V9.61414H12.9785V18.0067H11.0202ZM7.80307 18.0067V12.3579H9.76133V18.0067H7.80307Z"
          fill="currentColor"
        />
      </g>
    </g>
  </SvgIcon>
);

export default MeasureModelIcon;
